<template>
  <v-dialog :value="value" @input="v => v || close()" max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">データアップロード</span>
      </v-card-title>
      <v-card-text class="py-0">
        <span>アップロードデータ用途を選択してください。</span>
        <v-btn
          v-for="item in uploadTypes"
          :key="item.value"
          color="primary"
          large
          block
          @click="selectUploadType(item.value)"
          class="mt-3"
          :disabled="item.disabled"
          >{{ item.text }}</v-btn
        >
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="close()">閉じる</v-btn>
      </v-card-actions>
    </v-card>

    <drone-images-upload-dialog
      v-model="droneImagesUploadDialog"
      :plantId="plantId"
      @uploaded="onUploaded()"
      v-if="droneImagesUploadDialog"
    ></drone-images-upload-dialog>

    <image360-upload-dialog v-model="image360UploadDialog" :plantId="plantId" @uploaded="onUploaded()" v-if="image360UploadDialog"></image360-upload-dialog>

    <video-upload-dialog v-model="videoUploadDialog" :plantId="plantId" @uploadedVideo="onUploadedVideo"></video-upload-dialog>
  </v-dialog>
</template>
<script>
import DroneImagesUploadDialog from "./DroneImagesUploadDialog";
import Image360UploadDialog from "@/components/dialog/Image360UploadDialog";
import VideoUploadDialog from "@/components/dialog/VideoUploadDialog";

export default {
  name: "DataUploadDialog",
  components: {
    "drone-images-upload-dialog": DroneImagesUploadDialog,
    "image360-upload-dialog": Image360UploadDialog,
    "video-upload-dialog": VideoUploadDialog,
  },
  // props: ["value", "blockId"],
  props: ["value", "plantId"],
  data() {
    return {
      block: {},
      uploadTypes: [
        { text: "マップ・モデル作成", value: "map", disabled: false },
        { text: "図面", value: "diagram", disabled: true },
        { text: "THETAパノラマ画像", value: "360image", disabled: false },
        { text: "動画", value: "video", disabled: false },
      ],
      droneImagesUploadDialog: false,
      image360UploadDialog: false,
      videoDialog: false,
      videoUploadDialog: false,
    };
  },
  methods: {
    selectUploadType(type) {
      switch (type) {
        case "map":{
          this.droneImagesUploadDialog = true;
          break;
        }
        case "360image":{
          this.image360UploadDialog = true;
          break;
        }
        case "video":{
          this.videoUploadDialog = true;
          break;
        }
      }
    },
    onUploaded() {
      this.$emit("uploaded");
      this.close();
    },
    onUploadedVideo(folderId){
      this.close();
      this.$router.push('/video/' + folderId);
    },
    close() {
      this.$emit("input");
    },
  },
};
</script>
